import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpEvent} from "@angular/common/http";
import {filesResourceType} from "../components/modals/files-modal/configs/files-modal-config";
import {Observable} from "rxjs";
import {baseUrl} from "../constants/base-url";
import {FileParams, UploadFileData} from "../types/file.types";
import {FilesStatus, GetFilesStatusParams} from "../types/files-status.types";
import {downloadFileHeaders, emptyHttpHeaders} from "../models/http-headers";

@Injectable({
  providedIn: 'root'
})
export class FilesApiService {
  private http: HttpClient = inject(HttpClient);
  private url: string = `${baseUrl}/${filesResourceType.path}`;

  public uploadFile(uploadFileData: UploadFileData): Observable<HttpEvent<FileParams>> {
    const { formData, entityId, entityFileType } = uploadFileData;

    return this.http.post<FileParams>(`${this.url}/upload`, formData, {
      reportProgress: true,
      observe: 'events',
      headers: emptyHttpHeaders,
      params: { entityId: entityId, entityType: entityFileType }
    });
  }

  public downloadFile(id: number): Observable<HttpEvent<Blob>> {
    return this.http.get(`${this.url}/${id}/download`, {
      headers: downloadFileHeaders,
      responseType: 'blob',
      reportProgress: true,
      observe: 'events'
    });
  }

  public downloadFileNoEvents(id: number): Observable<Blob> {
    return this.http.get(`${this.url}/${id}/download`, {
      headers: downloadFileHeaders,
      responseType: 'blob'
    });
  }

  public downloadArchiveFiles(fileIds: Array<number>): Observable<Blob> {
    return this.http.post<Blob>(`${this.url}/download/archive`, fileIds, { responseType: 'blob' as 'json' });
  }


  public fetchFilesStatus({ id, path }: GetFilesStatusParams): Observable<FilesStatus> {
    return this.http.get<FilesStatus>(`${baseUrl}/${path}/${id}/file-status`);
  }
}
